import React, { Component } from 'react'
import httpClient from '../../utils/httpClient'
import {
    Toolbar,
    SaveButton,
    DeleteButton,
    Button,
    Confirm
} from 'react-admin'
import ButtonIcon from '@material-ui/icons/RotateLeft'

const Messages = {
    SUCCESS : 'success',
    WARNING : 'warning',
    ERROR : 'error'
}

class PostEditToolbar extends Component {
  state = {
    open: false
  }
  handleConfirm = () => {
    this.setState({ open: false})
    const { record: { id }, showNotification } = this.props
    httpClient(`${process.env.API_URL}/api/v1/usuarios/reset-password/${id}`, {
      method: 'PUT'
    }).then(response => {
      showNotification('Se ha enviado un email con la nueva contraseña', Messages.SUCCESS)
    }).catch(error => {
      showNotification('Ha Ocurrido un error, intentelo en unos momentos', Messages.ERROR)
    })
  };
  handleClick = () => this.setState({ open: true})
  handleDialogClose = () => this.setState({ open: false})
  render () {
    const { open } = this.state
    const { record: { username, is_active } } = this.props
    return (
      <Toolbar {...this.props} >
        <SaveButton {...this.props}/>
        <Button label={'Resetar Contraseña'} disabled={!is_active} onClick={this.handleClick}><ButtonIcon/></Button>
        <Confirm
          isOpen={open}
          title="Nueva Contraseña"
          content={`¿Esta seguro que desea reeviar la contraseña al usuario ${username}?`}
          onConfirm={this.handleConfirm}
          onClose={this.handleDialogClose}
        />
        <DeleteButton undoable={false} disabled={!is_active} {...this.props}/>
      </Toolbar>
    )
  }
}


export default PostEditToolbar
